import { render } from "./CollectionComments.vue?vue&type=template&id=499291c0"
import script from "./CollectionComments.vue?vue&type=script&lang=js"
export * from "./CollectionComments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__